import { Component } from '@angular/core';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-system-sub-nav',
  templateUrl: './system-sub-nav.component.html',
  styles: ``,
  standalone: false,
  host: {
    class: 'sub-nav-container',
  },
})
export class SystemSubNavComponent extends SubNavBaseComponent {}
